import { WhatsappTemplate } from '@/features/campaigns/v2/types/whatsappTemplates';
import { SmsTemplate } from '@/features/campaigns/v2/Sms/Templates/smsTemplateListFlowMapper';
import { getTemplatePlainText } from '@/features/campaigns/v2/utils/templateHtml';
import type { ComuniChannel } from './catalog';
import type { WorkspaceTemplateRow } from './partitionWorkspaceTemplates';

type EmailTemplateLike = {
  id: string;
  name: string;
  updatedAtLabel: string;
  category: string;
  subject: string;
};

export const buildWorkspaceTemplateRows = ({
  waTemplates,
  smsTemplates,
  emailTemplates,
}: {
  waTemplates: WhatsappTemplate[];
  smsTemplates: SmsTemplate[];
  emailTemplates: EmailTemplateLike[];
}): WorkspaceTemplateRow[] => [
  ...waTemplates.map((template) => {
    const plainBody = getTemplatePlainText(template.body);
    return {
      id: `wa-${template.id}`,
      channel: 'whatsapp' as ComuniChannel,
      name: template.name,
      detail: plainBody,
      formData: {
        template_name: template.name,
        template_body_text: plainBody,
        template_language: template.language,
        template_category: template.category.toUpperCase(),
      },
    };
  }),
  ...smsTemplates.map((template) => ({
    id: `sms-${template.id}`,
    channel: 'sms' as ComuniChannel,
    name: template.name,
    detail: template.previewText ?? '',
    formData: { template_name: template.name, template_text: template.previewText ?? '' },
  })),
  ...emailTemplates.map((template) => ({
    id: `em-${template.id}`,
    channel: 'email' as ComuniChannel,
    name: template.name,
    detail: template.updatedAtLabel,
    formData: { template_name: template.name, template_category: template.category, template_subject: template.subject },
  })),
];
